module.exports = __webpack_public_path__ + "static/media/etherium.871ac454.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/networks/etherium.svg
// module id = 428
// module chunks = 7